import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Blog from './Blog';
import Contact from './Contact';
import Footer from './Footer';

// Import your new legal-doc page components:
import AydinlatmaBeyani from './pages/AydinlatmaBeyani';
import CaymaHakki from './pages/CaymaHakki';
import GizlilikPolitikasi from './pages/GizlilikPolitikasi';
import IadeDegisimPolitikasi from './pages/IadeDegisimPolitikasi';
import MesafeliSatisSozlesmesi from './pages/MesafeliSatisSozlesmesi';
import OnBilgilendirmeFormu from './pages/OnBilgilendirmeFormu';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />

            {/* Legal document routes */}
            <Route path="/aydınlatma-beyani" element={<AydinlatmaBeyani />} />
            <Route path="/cayma-hakki" element={<CaymaHakki />} />
            <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
            <Route path="/iade-degisim-politikasi" element={<IadeDegisimPolitikasi />} />
            <Route path="/mesafeli-satis-sozlesmesi" element={<MesafeliSatisSozlesmesi />} />
            <Route path="/on-bilgilendirme-formu" element={<OnBilgilendirmeFormu />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
